"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformTransactionStatusFetcher = exports.PlatformTransactionStatus = void 0;
const utils_1 = require("../../utils");
var PlatformTransactionStatus;
(function (PlatformTransactionStatus) {
    PlatformTransactionStatus["Committed"] = "Committed";
    PlatformTransactionStatus["Aborted"] = "Aborted";
    PlatformTransactionStatus["Processing"] = "Processing";
    PlatformTransactionStatus["Dropped"] = "Dropped";
    PlatformTransactionStatus["Unknown"] = "Unknown";
})(PlatformTransactionStatus || (exports.PlatformTransactionStatus = PlatformTransactionStatus = {}));
class PlatformTransactionStatusFetcher {
    platformApi;
    attempts = 0;
    transactionId;
    currentStatus = PlatformTransactionStatus.Unknown;
    constructor(platformApi, transactionId) {
        this.platformApi = platformApi;
        this.transactionId = transactionId;
    }
    async fetch(timeout, delay) {
        const maxAttempts = timeout / delay;
        this.currentStatus = PlatformTransactionStatus.Processing;
        while (this.attempts < maxAttempts && !this.isCurrentStatusSettled()) {
            await utils_1.TimeUtils.sleep(delay);
            await this.platformApi.getTxStatus(this.transactionId).then((value) => {
                this.currentStatus = value.status;
            }, (error) => {
                if (error.message !== 'not found') {
                    this.currentStatus = PlatformTransactionStatus.Unknown;
                }
            });
            this.attempts += 1;
        }
        return this.currentStatus;
    }
    isCurrentStatusSettled() {
        return (this.currentStatus !== PlatformTransactionStatus.Unknown &&
            this.currentStatus !== PlatformTransactionStatus.Processing);
    }
}
exports.PlatformTransactionStatusFetcher = PlatformTransactionStatusFetcher;
